<script lang="ts">
  interface ITextPanel {
    title: string;
    description: string;
  }

  export let data: ITextPanel;
</script>

<section class="article-panel g-centered">
  {#if data.title}
    <h1 class="title">{data.title}</h1>
  {/if}

  <div class="rte">
    {@html data.description}
  </div>
</section>

<style lang="scss">
  .article-panel {
    padding-bottom: 40px;

    @include md {
      padding-bottom: 60px;
    }
  }

  .title {
    @include h1;
    margin-bottom: 20px;

    @include md {
      padding-bottom: 34px;
    }
  }
</style>
